import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';

const CovidStatement = ({covidMessage}: { covidMessage: string }) => {
    if (!covidMessage || covidMessage === '') {
        return null;
    }

    return (
        <div>
            <p className="covid-statement">
                <ReactMarkdown source={covidMessage} />
            </p>
        </div>
    );
};

export default CovidStatement;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/CovidStatement/index.tsx